module.exports = __webpack_public_path__ + "img/LobsterManiaSlotsLogo.ddfa144e.png";